import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { AlertController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { ConnectionService } from 'src/app/core/connection/connection.service';
import { RequestQueueService } from 'src/app/core/services/requestQueue/request-queue.service';
import { SyncService } from 'src/app/core/sync/sync.service';

@Component({
	selector: 'app-sync-button',
	templateUrl: './sync-button.component.html',
	styleUrls: ['./sync-button.component.scss']
})
export class SyncButtonComponent implements OnInit{

	constructor(
		private syncService: SyncService,
		private connectionService: ConnectionService,
		private alertController: AlertController,
		private requestQueueService: RequestQueueService
	) { 
	}

	ngOnInit(): void {
		this.syncService.lastSyncTime.subscribe(s => this.lastSyncTime = formatDate(s, 'MM/dd/yyyy hh:mm', 'en-US'));
	}

	public lastSyncTime : string;

	get isSyncing$(): Observable<boolean> {
		return this.syncService.isSyncing$;
	}

	get isOnline$(): Observable<boolean> {
		return this.connectionService.online$;
	}

	get hasFailedRequests$(): Observable<boolean> {
		return this.requestQueueService.hasFailedRequests$;
	}

	async manualSync(): Promise<void> {
		if (!this.connectionService.isOnline$.value) {
			return await this.alertOffline();
		}

		await this.syncService.sync();
	}

	async alertOffline(): Promise<void> {
		const offlineAlert = await this.alertController.create({
			header: 'Device Offline',
			message: 'Updates from the server are currently unavailable. Please try again when your device is online.',
			buttons: ['OK'],
		});

		await offlineAlert.present();
	}

}
